import React, { useRef } from 'react';
import _ from 'lodash';
import { usePartiesContext } from '../../context/PartiesContext';
import { getPartyByExpedientIdAndPartyId } from '../../helpers/logicDataParties';
import { initValuesFormParties } from '../forms/initValues';
import { typeParties } from '../../assets/typeParties';

const normalizePartyData = (partyData = {}) => {
  return Object.keys(partyData || {}).reduce((acc, key) => {
    const value = partyData[key];
    acc[key] = value === null || typeof value === 'undefined' ? '' : value;
    return acc;
  }, {});
};

export const PartiesItem = ({ party }) => {
  const { toggleDeleteParty, toggleShowAddForm, setCurrentPatyItem, setValues, idExpedient } =
    usePartiesContext();
  const {
    party_name,
    party_data = {},
    full_name = '',
    name = '',
    party_type = '',
    party_type_name = '',
  } = party;
  const isOpeningRef = useRef(false);

  const shortName =
    `${party_data.names || ''} ${party_data.paternal_surname || ''} ${party_data.maternal_surname || ''}`.trim();
  const resolvedName = full_name || name || party_name || shortName;
  const typeLabel =
    party_type_name ||
    (typeParties.find((item) => item.codigo === party_type) || {}).etiqueta ||
    party_type;

  const handleOpenForm = async () => {
    if (isOpeningRef.current) {
      return;
    }

    isOpeningRef.current = true;
    toggleShowAddForm();
    setValues((prev) => ({ ...prev, loading: true }));

    try {
      let selectedParty = party;
      const currentPartyData = party.party_data || {};

      if (_.isEmpty(currentPartyData) && idExpedient && party.id) {
        const partyDetail = await getPartyByExpedientIdAndPartyId(idExpedient, party.id);
        if (partyDetail) {
          selectedParty = {
            ...party,
            ...partyDetail,
            party_data: partyDetail.party_data || {},
          };
        }
      }

      const normalizedPartyData = normalizePartyData(selectedParty.party_data || {});

      setCurrentPatyItem(selectedParty);
      setValues((prev) => ({
        ...prev,
        formValues: {
          ...initValuesFormParties.formValues,
          ...normalizedPartyData,
          typeParts: selectedParty.party_type,
          is_show_cover: selectedParty.show_cover,
        },
      }));
    } finally {
      setValues((prev) => ({ ...prev, loading: false }));
      isOpeningRef.current = false;
    }
  };

  return (
    <div className="border border-secondary rounded d-flex align-items-center cursor-pointer user-select-none mb-2">
      <div className="container" onClick={handleOpenForm}>
        <div className="row">
          <div className="col font-weight-bold">{typeLabel}</div>
        </div>
        <div className="row">
          <div className="col">{resolvedName}</div>
        </div>
      </div>

      <div>
        <span
          className="ti-trash"
          style={{ color: 'red', fontWeight: 'bold', fontSize: '25px', cursor: 'pointer' }}
          onClick={() => toggleDeleteParty(party)}
        />
      </div>
    </div>
  );
};
